<template><div><h1 id="adressliste-gruppiert-nach-merkmalen" tabindex="-1"><a class="header-anchor" href="#adressliste-gruppiert-nach-merkmalen"><span>Adressliste gruppiert nach Merkmalen</span></a></h1>
<p>Adressliste gruppiert nach Merkmalen — Listet Adressen gruppiert nach Merkmalen auf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ergebnis dieser Auswertung ist eine Liste der Adressen, die im Adressfilter vorhanden sind und das eingegebene Selektionsmerkmal haben. Die Adressen werden nach den Merkmalen im Feld &quot;Sortierungsmerkmale&quot; gruppiert. Als letzte Gruppe erscheinen Adressen die keiner diesen Merkmalen haben. Innerhalb dieser Gruppen werden die Adressen nach Name und Ort sortiert. Pro Sortierungsmerkmal wird die Anzahl Adressen angezeigt.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Adressliste gruppiert nach Merkmalen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Adressfilter</dt>
<dd>Adressfilter</dd>
<dt>Selektionsmerkmal</dt>
<dd>Selektion von Adressen nach Merkmal</dd>
<dt>Sortierungsmerkmale</dt>
<dd>Sortierung der Adressen nach Merkmalen</dd>
<dt>letzte Spende zeigen?</dt>
<dd>Anzeige der letzten Spende ja/nein</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Merkmal</td>
<td>Personenmerkmal</td>
</tr>
<tr>
<td>Adrnum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Adressname</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort der Adresse</td>
</tr>
<tr>
<td>Strasse + Nr</td>
<td>Strasse und Hausnummer der Adresse</td>
</tr>
<tr>
<td>Ereignis</td>
<td>Ereignisnummer und -position</td>
</tr>
<tr>
<td>Datum</td>
<td>Ereignisdatum</td>
</tr>
<tr>
<td>Betrag</td>
<td>Betrag der letzten Spende</td>
</tr>
<tr>
<td>Projekt</td>
<td>Projektnummer</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Projektbezeichnung</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">                     Adressliste gruppiert nach Merkmalen</span>
<span class="line"> Ergebnis dieser Auswertung ist eine Liste der Adressen, die im Adressfilter</span>
<span class="line"> vorhanden sind und das eingegebene Selektionsmerkmal haben.</span>
<span class="line"> Die Adressen werden nach den Merkmalen im Feld "Sortierungsmerkmale"</span>
<span class="line"> gruppiert. Als letzte Gruppe erscheinen Adressen die keiner diesen</span>
<span class="line"> Merkmalen haben. Innerhalb dieser Gruppen werden die Adressen nach</span>
<span class="line"> Name und Ort sortiert. Adresse mit mehr als einem Merkmal erscheint</span>
<span class="line"> nur einmal in der Gruppe mit dem ersten Merkmal.</span>
<span class="line"> Pro Sortierungsmerkmal wird die Anzahl Adressen angezeigt.</span>
<span class="line"></span>
<span class="line"> Adressfilter.........: 55</span>
<span class="line"> Selektionsmerkmal....: wass</span>
<span class="line"> Sortierungsmerkmale..: ysj2,ysn4</span>
<span class="line"> letzte Spende zeigen?: ja</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Merkmal   Adrnum Name             Ort         Strasse + Nr   Ereignis  +  Datum     Betrag Projekt Bezeichnung</span>
<span class="line">------- -------- ---------------- ----------- -------------- ------------------ ---------- ------- ----------------</span>
<span class="line">ysj2     2466211 Romano Luigina   Bern        Schweizerhof-P</span>
<span class="line">ysj2     2405943 Schäppi Eduard   Igis</span>
<span class="line">ysj2     2304327 von Gunten Carol Thun        Bälliz 54</span>
<span class="line">Anzahl mit Merkmal ysj2: 3</span>
<span class="line"></span>
<span class="line">ysn4     2477468 Imhof Sabine     Niederwange Meriedweg 29</span>
<span class="line">ysn4     2299414 Lubenovic Iset   Niederhasli Gewerbestrasse</span>
<span class="line">ysn4     2471605 Schnellmann Fabi Schwyz      St. Martinstra</span>
<span class="line">Anzahl mit Merkmal ysn4: 3</span>
<span class="line"></span>
<span class="line">         2470207 Downtown Store   Biel/Bienne Untergasse 33</span>
<span class="line">         2474765 Lichtsteiner Ben Wolhusen    Strittenmatt 6</span>
<span class="line">         2466053 Lutz Stafanie    Niederwange Brüggbühlstras</span>
<span class="line">         2466105 Mögli Barbara    Bern        Reiterstrasse</span>
<span class="line">         2467527 Weber Mario      Bern        Tscharnerstras</span>
<span class="line">Anzahl ohne Gruppierungsmerkmal: 5</span>
<span class="line"></span>
<span class="line">Total Anzahl: 11</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


